/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppliedPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import PaymentCorrection from './PaymentCorrection/index'
import React from 'react'
import Refund from './Refund/index'
import ToPayment from './ToPayment/index'
import ToReceivable from './ToReceivable/index'



/** @type {import('Simple/types.js').View} */
export default function AppliedPayment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/TypeCell/AppliedPayment"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let transactionAppliedPaymentAppliedTypeValueData = fromData.useDataValue({ viewPath,
context: 'transaction',
path: 'applied_payment.applied_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: transactionAppliedPaymentAppliedTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ToReceivable'}>
<ToReceivable
  viewPath={`${viewPath}/ToReceivable`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ToPayment'}>
<ToPayment
  viewPath={`${viewPath}/ToPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Refund'}>
<Refund
  viewPath={`${viewPath}/Refund`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentCorrection'}>
<PaymentCorrection
  viewPath={`${viewPath}/PaymentCorrection`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}